import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-repay-payment-form',
    templateUrl: './repay-payment-form.component.html',
    styleUrls: ['./repay-payment-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class RepayPaymentFormComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
